module.exports = __webpack_public_path__ + "static/media/teamTwo.7e8ebe21.webp";